<dashboardnav>
  
    <cradua-app-configuration
    [appconfigurations]="appconfigurations$ | async"
    (appconfiguration)="onSubmitAppConfiguration($event)"
    (deleteAppConfigurationEvent)="onDeleteAppConfiguration($event)"
    *ngIf="(isLoading$ | async ) === false"
    >
  </cradua-app-configuration>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  